angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('components/engineers/viewEngineer.html',
    '<section id="viewEngineers" class="content dashboard public">\n' +
    '        <div class="container">\n' +
    '            <div class="row">\n' +
    '                <div class="col-sm-3">\n' +
    '                    <h2>This feature will be available soon</h2>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '</section>');
}]);
